/*
 * custom: back-to-top — floating button for long product grids.
 * Shows once the trigger card (theme setting, default the 30th) has
 * scrolled above the viewport; hides again above it. Desktop only —
 * below 990px the sticky tools bar carries its own Back to top. IntersectionObserver
 * only, no scroll listeners. Re-arms after Dawn's facets re-render.
 * Kept separate from custom-load-more.js so it can be reused on other
 * templates later.
 */
(() => {
  'use strict';

  const CONFIG = {
    container: '#ProductGridContainer',
    grid: '#product-grid',
    wrapper: '[data-custom-load-more]',
    button: '[data-custom-back-to-top]',
  };

  const button = document.querySelector(CONFIG.button);
  if (!button) return;
  let io = null;
  let armedCard = null;

  function reducedMotion() {
    return matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setVisible(visible) {
    button.classList.toggle('is-visible', visible);
    button.setAttribute('aria-hidden', visible ? 'false' : 'true');
    button.tabIndex = visible ? 0 : -1;
  }

  function arm() {
    if (io) io.disconnect();
    const wrapper = document.querySelector(CONFIG.wrapper);
    const grid = document.querySelector(CONFIG.grid);
    if (!wrapper || !grid) return;
    const trigger = parseInt(wrapper.dataset.backToTopTrigger, 10) || 30;
    const card = grid.querySelectorAll(':scope > li')[trigger - 1];
    armedCard = card || null;
    setVisible(false);
    if (!card) return; // fewer products than the trigger (yet): never shows
    // The root box extends (effectively) infinitely downward, so the
    // card is "intersecting" whenever it is in or below the viewport
    // and "not intersecting" only once it's above it. That makes the
    // observer fire on every crossing of the show boundary even when
    // a jump-scroll skips the frames where the card was in view —
    // with a plain root, a fast jump goes false->false and never fires.
    io = new IntersectionObserver(() => update(), { rootMargin: '0px 0px 999999px 0px' });
    io.observe(card);
  }

  function update() {
    if (!armedCard || !armedCard.isConnected) return;
    setVisible(armedCard.getBoundingClientRect().bottom < 0);
  }

  // Belt and braces alongside the observer: same rect check on a
  // throttled scroll listener (~100ms), for engines with quirky IO
  // delivery.
  let ticking = false;
  addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      setTimeout(() => {
        update();
        ticking = false;
      }, 100);
    },
    { passive: true }
  );

  button.addEventListener('click', () => {
    const container = document.querySelector(CONFIG.container);
    if (!container) return;
    container.tabIndex = -1;
    container.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    container.focus({ preventScroll: true });
  });

  // Re-arm when the grid is replaced (facets re-render) or when the
  // trigger card doesn't exist yet (small first page that lazy-loads
  // past the threshold later).
  const container = document.querySelector(CONFIG.container);
  if (container) {
    new MutationObserver(() => {
      if (!armedCard || !armedCard.isConnected) arm();
    }).observe(container, { childList: true, subtree: true });
  }
  arm();
})();
